import { z } from 'zod'

import { PaymentType } from '../enums'

// Messages are i18n keys: each app translates them.
const addressSchema = z.object({
  address: z.string().min(1, {
    message: 'cashRegister.settings.form.address.address.required',
  }),
  city: z.string().min(1, {
    message: 'cashRegister.settings.form.address.city.required',
  }),
  zip: z.string().min(1, {
    message: 'cashRegister.settings.form.address.zip.required',
  }),
  country: z.string().min(1, {
    message: 'cashRegister.settings.form.address.country.required',
  }),
})

export const CashRegisterSettingsFormSchema = z
  .object({
    cashRegisterIdentifier: z.string().min(1, {
      message: 'cashRegister.settings.form.cashRegisterIdentifier.required',
    }),
    amountThenPrice: z.boolean(),
    address: addressSchema,
    workplaceIdentifier: z.string().min(1, {
      message: 'cashRegister.settings.form.workplaceIdentifier.required',
    }),
    taxRates: z.array(z.string()).min(1, {
      message: 'cashRegister.settings.form.taxRates.required',
    }),
    defaultTaxRate: z.string().min(1, {
      message: 'cashRegister.settings.form.defaultTaxRate.required',
    }),
    printEmail: z.boolean(),
    printPhone: z.boolean(),
    paymentTypes: z.array(z.nativeEnum(PaymentType)).min(1, {
      message: 'cashRegister.settings.form.paymentTypes.required',
    }),
    warehouseId: z.string().optional(),
  })
  .refine((data) => data.taxRates.includes(data.defaultTaxRate), {
    message: 'cashRegister.settings.form.defaultTaxRate.mustBeEnabled',
    path: ['defaultTaxRate'],
  })

export type CashRegisterSettingsFormValues = z.infer<typeof CashRegisterSettingsFormSchema>
